// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"634ff1a7","239":"83eb7944","453":"37ee2208","732":"9055123e"}[chunkId] + ".chunk.js";
};